/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of trackers (patients) to display or load trackers */


(function () {
  'use strict';
  angular.module('vctracker')
    .component('trackerchooser', {
      restrict: 'E',
      bindings: {
        trackers: '<?',
        onselectcb: '&?'
      },
      template: `
        <div>
          <span class="btn btn-success btn-xs"
                ng-repeat="tracker in vm.trackers"
                uib-tooltip="Tracker hinzufügen"
                ng-click="vm.addTracker(tracker)">
            <i class="fa fa-plus"></i><i class="fa fa-line-chart"></i>&nbsp;{{tracker.name}}</span>
           <div ng-show="vm.trackers.length === 0" class="alert alert-info">Sie haben noch keine Tracker angelegt. <a ui-sref="settings.tracker" class="btn btn-primary" target="_blank">Tracker anlegen</a></div>
        </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', '$http', 'Rlog', 'Tracker', 'TrackerHelper', 'vertxEventBusService',
        function ($log, $http, Rlog, Tracker, TrackerHelper, vertxEventBusService) {
          let vm = this;
          vm.addTracker = addTracker;
          vm.$onInit = function () {
            // unless vcclient list has been passed for test purposes, retrieve vcclient list from web
            if (angular.isUndefined(vm.trackers)) {
              vm.trackers = Tracker.$search({active: true});
            }
          }; // $onInit()


          function addTracker(tracker) {
            $log.debug('vm.addTracker called');
            if (angular.isDefined(vm.onselectcb) && angular.isFunction(vm.onselectcb)) {
              $log.debug('calling parentsave for tracker: ', tracker);
              vm.onselectcb({tracker: tracker});
            }
          }

          vertxEventBusService.on('trackers.update', function (message) {
            $log.debug('debug: tracker update received: ', message);
            vm.trackers.$refresh().$then(function () {
              $log.debug('debug: trackerlist refreshed trackers');
            }, function (error) {
              $log.debug('debug: trackerlist refresh trackers failed: ', error);
            });
          });

        }] // controller
    }); // component

  // klammerfriedhof
}());
